module.exports = __webpack_public_path__ + "static/media/cervical-ripening-balloon-stylet-product.370dff37.jpg";